import { Mui } from "@osu/react-ui";
import ListItem from "./ListItem";
import { validations } from "../util/constants";

const List = ({ list = [], lastAction, updateLinks, isLoading, isSuccess }) => {
  return (
    <Mui.List>
      {list.map((link = {}, idx) => {
        return (
          <ListItem
            key={encodeURIComponent(link.title + idx)}
            link={link}
            reducer={updateLinks}
            index={idx}
            deletable={list.length > validations.quickLinks.min}
            lastAction={lastAction}
            arrayLength={list.length}
            isLoading={isLoading}
            isSuccess={isSuccess}
          />
        );
      })}

    </Mui.List>
  );
}

export default List;
